import React from "react";
import { IoSearchOutline } from "react-icons/io5";

const NoProductsFound = ({ message = "No Products Found", className = "" }) => {
  return (
    <div className={`no-products-container ${className}`}>
      <div className="no-products-content">
        <div className="no-products-icon">
          <IoSearchOutline />
        </div>
        <h3 className="no-products-title">{message}</h3>
        <p className="no-products-subtitle">
          We couldn't find any products matching your criteria.
        </p>
      </div>

      <style jsx>{`
        .no-products-container {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 300px;
          padding: 40px 20px;
          background: #f8f9fa;
          border-radius: 8px;
          margin: 20px 0;
        }

        .no-products-content {
          text-align: center;
          max-width: 400px;
        }

        .no-products-icon {
          font-size: 4rem;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #6c757d;
          margin-bottom: 20px;
          opacity: 0.6;
        }

        .no-products-title {
          font-size: 1.5rem;
          font-weight: 600;
          color: #495057;
          margin-bottom: 10px;
        }

        .no-products-subtitle {
          font-size: 1rem;
          color: #6c757d;
          margin: 0;
          line-height: 1.5;
        }

        @media (max-width: 768px) {
          .no-products-container {
            min-height: 250px;
            padding: 30px 15px;
          }

          .no-products-icon {
            font-size: 3rem;
            margin-bottom: 15px;
          }

          .no-products-title {
            font-size: 1.25rem;
          }

          .no-products-subtitle {
            font-size: 0.9rem;
          }
        }
      `}</style>
    </div>
  );
};

export default NoProductsFound;
